module.exports = __webpack_public_path__ + "img/file.95785e4d.svg";